import React from 'react';
import { connect } from 'react-redux';
import '../../styles/play_styles.scss';

class DescriptionPromo extends React.Component {

    state = {
        scale: false
    };
    componentDidMount() {

    }

    itemsToRender(items) {
        return items.map((item, key) => {
            return (<div key={key} className='play_card-i-dp'>
                <div>
                    <h4 className='play_title-i-dp'>{item.Title}</h4>
                    <div>
                        <p>{item.Text}</p>
                    </div>
                </div>
                <div>
                    <img src={item.Image} alt={item.Title} />
                </div>
            </div>);
        });
    }

    itemsToRenderAlt(items) {
        return items.map((item, key) => {
            return (<div key={key} className='play_card-i-dp'>
                <div>
                    <div>
                        <img src={item.Image} alt={item.Title} />
                    </div>
                    <div>
                        <p>{item.Text}</p>
                    </div>
                </div>

            </div>);
        });
    }

    render() {
        return (
            <div className='row'>
                <div>
                    <h2 className='play_title-dp'>{this.props.title}</h2>
                </div>
                <div>

                    {
                        !!this.props.alt ? this.itemsToRender(this.props.items) : this.itemsToRenderAlt(this.props.items)
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        result: state.pageReducer.result,
    };
};

export default connect(mapStateToProps, {})(DescriptionPromo);


